import type { MediaCount } from '@virginexperiencedays/components-v2/src/MediaGrid';
import type { Image, Product, Video } from '@virginexperiencedays/products';

const MEDIA_GRID_MAX_ITEMS = 4;

export type ExtendedMediaType = ({ type: 'video' } & Video) | ({ type: 'image' } & Image);

export function mediaGridExtractor(media: Product['media']): {
  media: ExtendedMediaType[];
  mediaCount: MediaCount;
} {
  const mediaArray: ExtendedMediaType[] = [];

  media?.video && mediaArray.push({ type: 'video', ...media.video });

  media?.mainImage && mediaArray.push({ type: 'image', ...media.mainImage });

  const imagesArray: ExtendedMediaType[] = Array.isArray(media?.images)
    ? media.images.map((img) => ({ type: 'image', ...img }))
    : [];

  mediaArray.push(...imagesArray);

  const allMediaArray = mediaArray.slice(0, MEDIA_GRID_MAX_ITEMS);

  return { media: allMediaArray, mediaCount: allMediaArray.length as MediaCount };
}
